import { render, staticRenderFns } from "./subscription-category-details.vue?vue&type=template&id=2c33916e&scoped=true&"
import script from "./subscription-category-details.ts?vue&type=script&lang=ts&"
export * from "./subscription-category-details.ts?vue&type=script&lang=ts&"
import style0 from "./subscription-category-details.scss?vue&type=style&index=0&id=2c33916e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c33916e",
  null
  
)

export default component.exports